const map = {
	"./call_dark.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/call_dark.svg",
	"./call_light.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/call_light.svg",
	"./heart_dark.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/heart_dark.svg",
	"./heart_light.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/heart_light.svg",
	"./mental_health_dark.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/mental_health_dark.svg",
	"./mental_health_light.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/mental_health_light.svg",
	"./perks_dark.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/perks_dark.svg",
	"./perks_light.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/perks_light.svg",
	"./question_dark.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/question_dark.svg",
	"./question_light.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/question_light.svg",
	"./smartphone_dark.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/smartphone_dark.svg",
	"./smartphone_light.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/smartphone_light.svg",
	"./writing_dark.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/writing_dark.svg",
	"./writing_light.svg": "./client/app/react-components/walk-through/assets/walkthrough/svg/writing_light.svg"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./client/app/react-components/walk-through/assets/walkthrough/svg sync recursive ^\\.\\/.*$";